/**
 * Makes protocol-less web addresses pass Zod's url() check (e.g. www.github.com).
 * Values that already include a scheme are left unchanged.
 */
export function normalizeOptionalUrl(val: unknown): string | undefined {
  if (val === undefined || val === null) {
    return undefined;
  }
  if (typeof val !== "string") {
    return undefined;
  }
  const s = val.trim();
  if (s === "") {
    return "";
  }
  if (/^[a-z][a-z0-9+.-]*:/i.test(s)) {
    return s;
  }
  if (s.startsWith("//")) {
    return `https:${s}`;
  }
  const looksLikeHost = /\./.test(s) || /^www\./i.test(s);
  if (!looksLikeHost) {
    return s;
  }
  const candidate = `https://${s}`;
  try {
    new URL(candidate);
    return candidate;
  } catch {
    return s;
  }
}
